import React, { useState } from "react";
import { FaRocket, FaBullseye, FaUsers, FaShieldAlt } from "react-icons/fa";
import "./AboutUs.css";
import aboutImage from "../uploads/ChatGPT Image Mar 24, 2026, 11_01_34 AM.png";
import founderImg from "../uploads/ertyu.jpg";
import ownerImg from "../uploads/anisha.png";
import hrImg from "../uploads/user.png";
import adminImg from "../uploads/user.png";
import projectImg from "../uploads/rev.jpeg"; 
import teamLead1Img from "../uploads/user.png"; 
import teamLead2Img from "../uploads/user.png"; 
import teamLead3Img from "../uploads/user.png"; 
import teamLead4Img from "../uploads/user.png"; 
import teamLead5Img from "../uploads/user.png";
import teamLead6Img from "../uploads/user.png";

function AboutUs() {
  const [modalData, setModalData] = useState(null);

  const teamFlow = [
    {
      id: "founder",
      name: "Founder",
      img: founderImg,
      role: "RDS Technology",
      description: "Leads overall vision and strategy of the company.",
      children: [
        {
          id: "admin",
          name: "Admin",
          img: adminImg,
          role: "Administration",
          description: "Manages office operations and administrative tasks."
        },
        {
          id: "owner",
          name: "Owner",
          img: ownerImg,
          role: "RDS Technology",
          description: "Manages operations, HR, and admin functions.",
          children: [
            {
              id: "projectCoordinator",
              name: "Project Coordinator",
              img: projectImg,
              role: "Project Management",
              description: "Coordinates projects across teams.",
              children: [
                {
                  id: "teamLead1",
                  name: "Team Leader",
                  img: teamLead1Img,
                  role: "XML",
                  description: "Leads a team for project execution."
                },
                {
                  id: "teamLead2",
                  name: "Team Leader",
                  img: teamLead2Img,
                  role: "E-PUB",
                  description: "Leads a team for project execution."
                },
                {
                  id: "teamLead3",
                  name: "Team Leader",
                  img: teamLead3Img,
                  role: "Invoice",
                  description: "Leads a team for project execution."
                },
                {
                  id: "teamLead4",
                  name: "Team Leader",
                  img: teamLead4Img,
                  role: "E-Commerce",
                  description: "Leads a team for project execution."
                },
                {
                  id: "teamLead5",
                  name: "Team Leader",
                  img: teamLead5Img,
                  role: "POD",
                  description: "Leads a team for project execution."
                },
                {
                  id: "teamLead6",
                  name: "Team Leader",
                  img: teamLead6Img,
                  role: "Development Team",
                  description: "Leads a team for project execution."
                }
              ]
            }
          ]
        },
        {
          id: "hr",
          name: "HR",
          img: hrImg,
          role: "Human Resources",
          description: "Handles employee welfare, recruitment, and HR tasks."
        }
      ]
    }
  ];


  const renderNode = (node) => (
  <div className="tree-node" key={node.id}>
    
    <div
      className={`flow-node flow-node-${node.id} ${node.children ? "has-children" : "leaf-node"}`}
      onClick={() => setModalData(node)}
    >
      <div className="flow-image-wrap">
        <img src={node.img} alt={node.name} />
        {node.id.startsWith("teamLead") && (
          <span className="flow-role-badge">{node.role}</span>
        )}
      </div>
      <p>{node.name}</p>
    </div>

    {node.children && (
      <div
        className={`tree-children tree-children-${node.id} ${
          node.children.length === 1 ? "single-child" : "multiple-children"
        }`}
      >
        {node.children.map((child) => (
          <div className={`tree-child tree-child-${child.id}`} key={child.id}>
            {renderNode(child)}
          </div>
        ))}
      </div>
    )}
  </div>
);

  return (
    <div className="about-wrapper">

      {/* ===== HERO ===== */}
      <section className="about-hero">
        <div className="hero-content">
          <div className="title-group">
            <span className="hero-label">ABOUT</span>
            <h1 className="hero-main-title">
              RDS <span className="premium-text">Technology</span>
            </h1>
          </div>
          <p className="hero-subtext">
            Driving innovation with smart, scalable and future-ready digital solutions.
          </p>
        </div>
      </section>

      {/* ===== ABOUT SECTION ===== */}
      <section className="about-section">
        <div className="about-left">
          <img src={aboutImage} alt="About Company" />
        </div>
        <div className="about-right">
          <h2>Who We Are</h2>
          <p>
            RDS Technology specializes in scalable web applications,
            enterprise systems, and digital transformation strategies.
          </p>
          <p>
            We blend creativity, technology, and strategy to help businesses
            adapt and thrive in today&apos;s competitive digital ecosystem.
          </p>

          <div className="stats">
            <div>
              <h3>2025</h3>
              <span>Founded</span>
            </div>
            <div>
              <h3>Startup</h3>
              <span>Growing Company</span>
            </div>
            <div>
              <h3>Innovative</h3>
              <span>Digital Solutions</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== MISSION & VISION ===== */}
      <section className="mission-vision">
        <div className="mv-card">
          <FaBullseye className="mv-icon" />
          <h3>Our Mission</h3>
          <p>
            Empower businesses through innovative, reliable, and
            future-focused digital solutions.
          </p>
        </div>
        <div className="mv-card">
          <FaRocket className="mv-icon" />
          <h3>Our Vision</h3>
          <p>
            To become a globally trusted technology partner recognized
            for excellence and innovation.
          </p>
        </div>
      </section>

      {/* ===== WHY US ===== */}
      <section className="why-us">
        <h2>Why Choose Us?</h2>
        <div className="why-grid">
          <div className="why-card">
            <FaUsers className="why-icon" />
            <h4>Experienced Team</h4>
            <p>Skilled professionals delivering high-quality solutions.</p>
          </div>
          <div className="why-card">
            <FaShieldAlt className="why-icon" />
            <h4>Reliable Support</h4>
            <p>Dedicated assistance and long-term technical support.</p>
          </div>
          <div className="why-card">
            <FaRocket className="why-icon" />
            <h4>Scalable Systems</h4>
            <p>Future-ready architecture built for growth.</p>
          </div>
          <div className="why-card">
            <FaBullseye className="why-icon" />
            <h4>Client Focused</h4>
            <p>Your goals drive our technology strategy.</p>
          </div>
        </div>
      </section>

      {/* ===== TEAM FLOWCHART ===== */}
      <section className="team-section">
        <h2 className="team-title">Leadership Flow Chart</h2>
        <div className="flowchart-container tree-container">
          {teamFlow.map((node) => renderNode(node))}
        </div>

        {/* MODAL */}
        {modalData && (
          <div
            className="modal-overlay"
            onClick={() => setModalData(null)}
          >
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={modalData.img} alt={modalData.name} />
              <h3>{modalData.name}</h3>
              <p className="role">{modalData.role}</p>
              <p className="desc">{modalData.description}</p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}

export default AboutUs;
